import { render, staticRenderFns } from "./QuestionsAlert.vue?vue&type=template&id=95a58632&"
import script from "./QuestionsAlert.vue?vue&type=script&lang=js&"
export * from "./QuestionsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports